import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import Grid from '@ntuctech/devex-tangram/Grid';
import Box from '@ntuctech/devex-tangram/Box';
import { Typography } from '@ntuctech/devex-tangram';
import { numberFormat } from '../../lib/utils';
import { SCREEN_SIZE } from '../../lib/mediaQuery';
import { DEFAULT_TITLE } from '../../constants';

const EgftVoucherTitle = styled.h5`
  font-family: 'Lato', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 29px;
  line-height: 40px;
  text-align: center;
  color: #333333;
  padding: 20px 0 15px 0;
  ${SCREEN_SIZE.Only.Mobile} {
    padding-left: 15px;
    padding-right: 15px;
  }
  ${SCREEN_SIZE.From.MobileL} {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
const EgftVoucherText = styled.p`
  font-family: 'Lato', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #333333;
  ${SCREEN_SIZE.Only.Mobile} {
    padding-left: 15px;
    padding-right: 15px;
  }
  ${SCREEN_SIZE.From.MobileL} {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
const ReceverTopImgSec = styled.div`
  text-align: center;
  ${SCREEN_SIZE.Only.Mobile} {
    padding-left: 15px;
    padding-right: 15px;
  }
  ${SCREEN_SIZE.From.MobileL} {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
const ReceiverTopIcon = styled.div`
  max-width: 328px;
  margin: 0 auto;
  text-align: center;
  img {
    width: 100%;
    border-radius: 5px;
  }
`;
const VoucherBalance = styled.div`
  text-align: center;
  h6 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #333333;
  }
  h2 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 900;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    color: #333333;
    margin-top: 5px;
  }
`;

const ValueValiditySec = styled.div`
  > div > div > div:nth-child(1) {
    border-right: 1px solid #eaeaea;
  }
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
  h6 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #333333;
  }
  h5 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #333333;
  }
`;
const RmvInnerPad = styled.div`
  ${SCREEN_SIZE.From.Tablet} {
    > div:nth-child(1) {
      padding: 0 0;
    }
    > div:nth-child(1) > div:nth-child(1) {
      padding-left: 0;
    }
    > div:nth-child(1) > div:nth-last-child(1) {
      padding-right: 0;
    }
  }
`;

const StyledLabel = styled.div`
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #666666;
  flex: none;
  order: 2;
  flex-grow: 0;
  padding: 0 20.5px 32px;
`;

const VoucherInfo = ({ voucherData = {} }) => {
  const { personalization, metadata, balance, initialBalance, expiresAt } = voucherData;
  const defaultSrc =
    'https://media.nedigital.sg/gifting/files/a48585e0-85f2-4f0d-ba5b-55c9c745e1e6/E-Gift_Voucher_Generic_03.svg';
  return (
    <>
      {metadata?.senderName ? (
        <>
          <EgftVoucherTitle>
            Your {DEFAULT_TITLE} from {metadata?.senderName}!
          </EgftVoucherTitle>
          {personalization?.message && (
            <EgftVoucherText>{`"${personalization?.message}" – ${metadata?.senderName}`}</EgftVoucherText>
          )}
        </>
      ) : (
        <>
          <EgftVoucherTitle>
            {personalization?.title
              ? `${personalization.title}${
                  personalization?.name ? ` - ${personalization.name}` : ''
                }`
              : `Your ${DEFAULT_TITLE}${
                  personalization?.name ? ` - ${personalization?.name}` : ''
                }`}
          </EgftVoucherTitle>
          {personalization?.message && (
            <EgftVoucherText>{`"${personalization?.message}"`}</EgftVoucherText>
          )}
        </>
      )}
      <ReceverTopImgSec>
        <Box mt={4} mb={2}>
          <ReceiverTopIcon>
            <img src={metadata?.metadata?.image || defaultSrc} alt="" width="100%" height="auto" />
          </ReceiverTopIcon>
        </Box>
      </ReceverTopImgSec>
      <VoucherBalance>
        <Typography variant="h6" data-testid="title">
          {DEFAULT_TITLE} balance
        </Typography>
        <Typography variant="h1">{numberFormat(balance)}</Typography>
      </VoucherBalance>
      <ValueValiditySec>
        <RmvInnerPad>
          <Grid container>
            <Grid item xs={6}>
              <h6>Original value</h6>
              <h5>{numberFormat(initialBalance?.toFixed(2))}</h5>
            </Grid>
            {/* <Grid item xs={2}>
        </Grid> */}
            <Grid item xs={6}>
              <h6>Expires on</h6>
              <h5>{moment(expiresAt).format('DD MMM YYYY')}</h5>
            </Grid>
          </Grid>
        </RmvInnerPad>
      </ValueValiditySec>
      <StyledLabel>
        This voucher can be used more than once to pay for multiple transactions.
      </StyledLabel>
    </>
  );
};

export default VoucherInfo;
